import AmexIcon from '@/assets/icons/payment/amex.svg?react';
import ApplePayIcon from '@/assets/icons/payment/applePay.svg?react';
import DiscoverIcon from '@/assets/icons/payment/discover.svg?react';
import GooglePayIcon from '@/assets/icons/payment/googlePay.svg?react';
import MastercardIcon from '@/assets/icons/payment/mastercard.svg?react';
import VisaIcon from '@/assets/icons/payment/visa.svg?react';
import ShieldIcon from '@/assets/icons/shield.svg?react';
import { cn } from '@/lib/cn';

interface SecuredPaymentProps {
  className?: string;
}

export const SecuredPayment = ({ className }: SecuredPaymentProps) => {
  return (
    <div className={cn('flex items-center justify-between gap-2', className)}>
      <div className="flex items-center gap-2">
        <ShieldIcon className="size-6" />
        <p className="text-sm">Secured Payment</p>
      </div>

      <div className="flex items-center gap-0.5">
        <GooglePayIcon className="size-6" />
        <ApplePayIcon className="size-6" />
        <VisaIcon className="size-6" />
        <MastercardIcon className="size-6" />
        <AmexIcon className="size-6" />
        <DiscoverIcon className="size-6" />
      </div>
    </div>
  );
};
